/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Disc(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M188.29883,43.31128a8.00224,8.00224,0,0,0-1.35889-.94751,103.67838,103.67838,0,1,0,1.35889.94751ZM128,152a24,24,0,1,1,24-24A24.0275,24.0275,0,0,1,128,152Zm88-24c0,2.47168-.10791,4.91833-.30859,7.339l-47.71875-8.41419a39.84182,39.84182,0,0,0-10.95777-26.41552l27.77808-39.671A87.83762,87.83762,0,0,1,216,128Z" />
    </Svg>
  );
}

export default Disc;
